import Axios from 'axios';
import Vue from 'vue';
import i18n from '../../i18n';
import { API_HOST } from '../../config/app-const';

const state =  {
  affiliations: {
    isBusy: false,
    data: null,
    error: null
  }
};

const mutations = {
  LOAD_AFFILIATIONS_BUSY: (state, payload) => {
    state.affiliations.isBusy = payload;
  },
  LOAD_AFFILIATIONS_SUCCESS: (state, payload) => {
    state.affiliations.data = payload.data;
    state.affiliations.error = null;
  },
  LOAD_AFFILIATIONS_FAIL: (state, payload) => {
    state.affiliations.data = null;
    state.affiliations.error = payload;
  }
};

const actions = {
  getAffiliations: ({ commit, rootState }, { projectId, pagination }) => {
    commit('LOAD_AFFILIATIONS_BUSY', true);

    const { accessToken } = rootState.user.user.data;
    const config = {
      headers: { Authorization: `Token token=${accessToken}` }
    };

    //in this case in pagination we will only have:searchQuery and perPage since this is a select list
    let query = '';
    if(pagination) {
      query = '?';
      Object.keys(pagination).map((param, i) => {
          query += `${param}=${pagination[param]}${i !== Object.keys(pagination).length - 1 ? '&' : ''}`;
        }
      );
    }

    Axios
      .get(`${API_HOST}/analysis/editor/${projectId}/affiliations${query}`, config)
      .then(response => {
        commit('LOAD_AFFILIATIONS_SUCCESS', response.data)
      })
      .catch(error => {
        Vue.notify({
          group: 'store_notifications',
          type: 'error',
          text: i18n.t('messages.request.error')});

        console.error(error);
        commit('LOAD_AFFILIATIONS_FAIL', error)
      })
      .finally(() => commit('LOAD_AFFILIATIONS_BUSY', false));
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
};